/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Limited_Procedure_ViolationInputs */



/**
* | output |
* | --- |
* | "Limited Procedure Violation" |
*
* @param {Sanction_Sub_Limited_Procedure_ViolationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_limited_procedure_violation = /** @type {((inputs?: Sanction_Sub_Limited_Procedure_ViolationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Limited_Procedure_ViolationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Violation de Procédure Limited")
	if (locale === "es") return /** @type {LocalizedString} */ ("Violación de Procedimiento Limited")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Violação de Procedimento Limited")
	if (locale === "it") return /** @type {LocalizedString} */ ("Violazione di Procedura Limited")
	return /** @type {LocalizedString} */ ("Limited Procedure Violation")
});